import React from 'react';
import RedirectLegal from './RedirectLegal';

export default function Privacy() {
  return <RedirectLegal care="confidentialitate" />;
}
